// extracted by mini-css-extract-plugin
export var attachmentContainer = "_n9-0";
export var fileList = "_n9-2";
export var removeFileButton = "_n9-1";